import store from "@/store";

export default {
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	data() {
		return {
			roles: [
                {name: 'Admin', value: 'Admin'},
                {name: 'HQ Staff', value: 'HQ Staff'},
                {name: 'RPK User', value: 'RPK User'},
				{name: 'Viewer', value: 'Viewer'},
            ],
		}
	},
	computed: {
		isRoot() { return store.getters.getSession != null && store.getters.getSession.employee.emailAddress == "root@secure365.com.my" },
		isAdmin() { return store.getters.getSession != null && store.getters.getSession.roles.includes("Admin") },
		isHQStaff() { return store.getters.getSession != null && !store.getters.getSession.roles.includes("Admin") && store.getters.getSession.roles.includes("HQ Staff") },
		isRPKUser() { return store.getters.getSession != null && !store.getters.getSession.roles.includes("Admin") && !store.getters.getSession.roles.includes("HQ Staff") && store.getters.getSession.roles.includes("RPK User") },
		isViewer() { return store.getters.getSession != null && !store.getters.getSession.roles.includes("Admin") && !store.getters.getSession.roles.includes("HQ Staff") && store.getters.getSession.roles.includes("Viewer") },
		isApproval() { return store.getters.getSession != null && store.getters.getSession.employee.isApproval }
	},
};